import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


export const TOASTS = {
    success: (message) => {return toast.success(message)},
    error: (message) => {return toast.error(message)},
    warning: (message) => {return toast.warning(message)},
    info: (message) => {return toast.info(message)},
}